import parse from "html-react-parser";
import { useEffect, useState } from "react";

const AssociateModuleCards = (props) => {
    const { items, cardCheck, handleSelectedCheckboxes, checkboxSections } = props;

    return (
        <><span><input key={items.moduleId} type='checkbox' defaultChecked={checkboxSections[items.moduleId]} onChange={(e) => handleSelectedCheckboxes(e, items.moduleId, cardCheck, items)} /></span>
            <div className={`${false
                ? "selectedNextModule"
                : ""
                } associate-module-card`} key={items.moduleId}>

                <div className="module-card" /* onClick={() => selectedCardHandler(items)} */>
                    <h6 className="card-name">Module Name</h6>
                    <p className="card-content">{items.moduleCode}</p>
                    {/* <p > <span className="next-module-card-efficacy">{items["primaryClaim"] ? items["primaryClaim"][0] : ''}</span></p> */}
                    <p className="card-claim">Claim</p>
                    <p className="card-description">{parse(items.primaryClaim || "")} </p>
                </div>
            </div>
        </>
    )
}

export default AssociateModuleCards;